import React from 'react';
import './Officers.css';

function Officers() {
  const officers = [
    {
      position: "President",
      name: "Prof. Ram Tawakya Singh",
      qualification: "Ph.D.",
      details: "Former Dean of Sc & Head, P.G. Deptt. of Chemistry, V.K.S.University, Arrah (Bihar)",
      email: "singhramtawakya@gmail.com",
      color: "#667eea"
    },
    {
      position: "Vice-President",
      name: "Prof. Raj Kumar Prasad",
      qualification: "Ph.D., B.L.",
      details: "Former Head, P.G. Deptt. of Maths., V.K.S.University, Arrah (Bihar)",
      email: "",
      color: "#764ba2"
    },
    {
      position: "Vice-President",
      name: "Prof. Dhyanendra Kumar",
      qualification: "Ph.D.",
      details: "Ex-Head, P.G. Deptt. of Zoology. V.K.S. University, Arrah (Bihar), Ex. Member of Executive Committee (I.S.C.A), Former Treasurer (ISCA) Science & Technology, Govt. of India.",
      email: "",
      color: "#764ba2"
    },
    {
      position: "Secretary",
      name: "Dr. Ashwani Kumar Sinha",
      qualification: "Ph.D., D.Sc. (New Delhi)",
      details: "Deptt. of Maths., M.C.A. (V.K.S. Univ.) Arrah, Member of Sectional Committee of the Section of Mathematical Sciences (including Statistics) for 2013-14 (101st ISCA)",
      email: "mathashwani3@gmail.com",
      color: "#f093fb"
    },
    {
      position: "Joint Secretary",
      name: "Prof. Alok Kumar",
      qualification: "Ph.D.",
      details: "Head, P.G. Deptt of Maths., Ex-Principal, Maharaja College, Arrah (Bihar)",
      email: "alok3545@yahoo.com",
      color: "#4facfe"
    },
    {
      position: "Treasurer",
      name: "Dr.(Smt.) Rashmi Sinha",
      qualification: "Ph.D.",
      details: "Deptt. of Chemistry, H.D. Jain College, Arrah (Bihar)",
      email: "rashmisinha.chem@gmail.com",
      color: "#43e97b"
    }
  ];

  return (
    <section id="officers" className="officers-section">
      <div className="section-container">
        <h2 className="section-title">Our Officers</h2>
        <p className="section-subtitle">Meet the dedicated team behind our journal</p>

        <div className="officers-grid">
          {officers.map((officer, index) => (
            <div key={index} className="officer-card" style={{'--card-color': officer.color}}>
              <div className="officer-header">
                <div className="officer-badge">{officer.position}</div>
              </div>
              <div className="officer-body">
                <h3 className="officer-name">{officer.name}</h3>
                <p className="officer-qualification">{officer.qualification}</p>
                <p className="officer-details">{officer.details}</p>
                {officer.email && (
                  <div className="officer-contact">
                    <span className="email-icon">✉</span>
                    <a href={`mailto:${officer.email}`} className="officer-email">
                      {officer.email}
                    </a>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Officers;
